import {
  Experiment,
  HeaderNotice,
  MainDataFragmentFragment,
  TopDataFragmentFragment,
  Order,
  PremiumManufacturer,
  Sdk,
  SeoTags,
  Store
} from '@/network/graphql.g'
import { MockSdk } from '@/network/mocks/sdk'
import { MhubApiData } from '@/network/models/mhub'
import { GetServerSidePropsContext, Redirect } from 'next'
import { Session } from './auth/session'

export {}

interface OpenAdvisor {
  sizeChartId: string
  language: string
}

export enum KeyEvent {
  Enter = 'Enter'
}

declare global {
  interface Window {
    SizeId: {
      openAdvisor: (openAdvisor: OpenAdvisor) => void
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  type Rest = Record<string, any>

  type GetServerSideProps<T> =
    | {
        props: T & { seoTags?: SeoTags } & {
          key?: string
        } & {
          mainData?: MainDataFragmentFragment
          order?: Order
          disableDaktela?: boolean
          topData?: TopDataFragmentFragment
        }
      }
    | { notFound: boolean }
    | { redirect: Redirect }

  type GetBaseServerSideProps<T> =
    | {
        props: BaseServerSideProps<T>
      }
    | { notFound: boolean }
    | { redirect: Redirect }

  type GetServerSidePropsFuncProps = {
    context: GetServerSidePropsContext
    session: Session
    sdk: Sdk
    mockSdk?: MockSdk
    sessionId: string
    withMainNavigation: boolean
    withTopNavigation: boolean
    withStore: boolean
    store?: Store
    premiumManufacturers?: PremiumManufacturer[]
    runningExperiments: Experiment[]
    runningUserExperiments: string
  }

  type BaseServerSideProps<T> = T & BaseAppProps

  type BaseAppProps = MhubApiData & {
    session: Session
    mainNavigation
    topNavigation
    store: Store
    premiumManufacturers: PremiumManufacturer[]
    order: Order
    host: string
    referer: string
    facebookRegistration: boolean
    ip: string
    serverTime: number
    seoTags?: SeoTags
    runningExperiments: Experiment[]
    runningUserExperiments: string
    disableDaktela?: boolean
    headerNotice?: HeaderNotice
  }
}
